import "./AssignToggle.styles.scss";
import React from "react";
import { useTranslation } from "react-i18next";
import { Toggle } from "components";
import {
  useOrganizationSettings,
  getPatientWordPlural,
} from "utils/hooks/organizations/useOrganizationSettings";

type AssignToggleProps = {
  checked: boolean;
  label: string;
  onChange: (e: any) => void;
  extraClass?: string;
  labelStyle?: string;
  ref?: any;
  disabled?: boolean;
};

const AssignToggle = ({
  checked,
  label,
  onChange,
  extraClass,
  labelStyle,
  ref,
  disabled,
}: AssignToggleProps) => {
  const { t } = useTranslation("common");
  const { settings: orgSettings } = useOrganizationSettings();

  return (
    <div
      className={`toggle-default ${extraClass && extraClass} ${
        disabled ? "disabled" : ""
      }`}
    >
      <div className={labelStyle ? labelStyle : "toggle-default_label"}>
        {t(label, { patientWordPlural: getPatientWordPlural(orgSettings) })}
      </div>
      <Toggle
        name={"default"}
        checked={checked}
        onChange={onChange}
        forwardRef={ref}
      />
    </div>
  );
};

export default AssignToggle;
